<template>
  <section class="section help" :class="{open: show}">
    <transition name="fade">
      <div class="leftBackdrop" v-if="show"
        v-on:click="close"></div>
    </transition>
    <div class="rightContent">
      <div class="tree"></div>
      <div class="rightContentIn">
        <div class="header">
          <div class="backBtn" v-on:click="close"></div>
        </div>
        <div class="menuCnt">
          <h4>Bantuan</h4>
          <div class="menuSc">
            <div class="menuItem loadingPrice" v-if="loading"></div>
            <div v-else>
              <div :class="{menuItem: true, locked: point < item.point}"
                v-for="(item, i) in price" :key="i">
                <div class="q">{{item.q}}</div>
                <div class="a">{{item.a}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <LevelClaimed ref="levelClaimed"/>
  </section>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import LevelClaimed from '@/components/LevelClaimed.vue';

export default {
  name: 'home',
  components: { Confirmation, LevelClaimed },
  data() {
    return {
      st: 'reg',
      point: 0,
      loading: true,
      show: false,
      price: [
        {
          q: 'Cara bermain',
          a: `Ikuti misi harian yang ada di Team Up For Impact Everyday
            dan dapatkan 100 poin untuk join dan 100 poin untuk share di medsos.`,
        },
        {
          q: 'Cara Klaim Aksesori',
          a: `Klik bagian poin di atas. Aksesori yang sudah kamu buka akan tampil.
            Klik klaim untuk  mendapatkannya.`,
        },
        {
          q: 'Cara Ganti Aksesori',
          a: `Pada icon bagian atas kamu bisa klik icon Pot,
            kamu bisa memilih pot yang sudah kamu klaim.`,
        },
        {
          q: 'Berapa Poin Untuk Mendapatkan Pohon?',
          a: `Kumpulkan hingga 1.400 poin. Satu pohon akan ditanam atas namamu.
            Kamu akan dikabari  melalui email tentang lokasi penanaman
            pohonmu dan perkembangannya.`,
        },
        {
          q: 'Apakah Saya Bisa Donasi Pohon?',
          a: `Kamu bisa mengikuti program donasi pohon yang tersedia dari
            mitra kami. Hubungi contact@teamupforimpact.org`,
        },
        {
          q: 'Dimana Lokasi Pohon Saya?',
          a: `Lokasi akan disesuaikan dengan ketersediaan lahan. Kamu akan
            dikabari melalui email pada saat pohonmu sudah tersedia.`,
        },
      ],
      claimedCount: 0,
      nextPrice: 0,
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    doNothing() {},
    open() {
      this.show = true;
      this.getData();
    },
    close() {
      this.show = false;
    },
    getData() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    // Check login
    this.point = this.$session.get('point') || 0;
    // this.$http.get(this.$config.uri('user/price')).then((r) => {
    //   this.loading = false;
    //   this.price = (r.data.status === 200) ? r.data.data : [];
    //   this.claimedCount = (r.data.status === 200) ? r.data.claimedCount : [];
    //   this.nextPrice = (r.data.status === 200) ? r.data.nextPrice : 0;
    // });
  },
};
</script>

<style scoped lang="scss">
.section.help{
  position: fixed;
  right: 0; top: 0; bottom: 0;
  left: auto;
  padding: 0;
  z-index: 9997;
  .rightContent{
    position: fixed;
    top: 0; bottom: 0;
    background-color: #e6e1c1;
    box-sizing: border-box;
    width: 480px;
    z-index: 3;
    left: -480px;
    transition: all .5s ease;
    overflow: hidden;
    @media (max-width: 680px) {
      width: 96%; left: -96%;
    }
    .tree{
      position: absolute;
      left: 0; right: -10px; bottom: 0; top: 0;
      background-image: url(../assets/FG-Kanan.svg);
      background-size: auto 120px;
      background-position: right bottom;
      background-repeat: no-repeat;
    }
    .rightContentIn{
      padding: 0 10px 40px;
      box-sizing: border-box;
      position: relative;
      z-index: 3;
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
    }
  }
  .leftBackdrop{
    position: fixed;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: #000;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    transition: all .3s ease;
  }
  &.open{
    .rightContent{
      left: 0;
    }
  }
  .header{
    padding: 16px 20px 0;
    @media (min-width: 480px) {
      padding-left: 10px;
    }
    .backBtn{
      margin-left: auto;
      width: 46px; height: 46px;
      border-radius: 50%;
      background-color: #fff;
      background-image: url(../assets/arrow-back.png);
      background-size: 22px auto;
      background-position: center;
      background-repeat: no-repeat;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #f5f5f5;
      }
    }
    h4{
      font-size: 24px;
      margin: 16px 0 14px;
      color: #006519;
    }
  }
  .profilePict{
    width: 94px; height: 94px;
    background-color: #ccc;
    border-radius: 50%;
    margin: 0 auto 16px;
    background-position: center;
    background-size: cover;
  }
  .profileInfo{
    text-align: center;
    padding-bottom: 20px;
    h4{
      margin: 0;
      font-size: 20px;
    }
    p{
      margin: 0;
      font-size: 15px;
    }
  }
  .expCnt{
    background-color: rgba(255, 255, 255, .7);
    margin: 0 10px 10px;
    border-radius: 10px;
    padding: 16px 20px 20px;
    position: relative;
    h4{
      margin: 0 0 6px;
      font-size: 16px;
    }
    .expLabel{
      position: absolute;
      right: 20px; top: 18px;
      font-size: 14px;
    }
    .theExp{
      height: 12px;
      background-color: #ccc;
      border-radius: 50px;
      .exp{
        height: 100%;
        max-width: 100%;
        background-color: #8EC642;
        // background-color: #6aa722;
        border-radius: 50px;
      }
    }
    .info{
      font-size: 12px;
      color: #555;
      text-align: right;
      margin: 5px 5px 0;
    }
  }
  .progressCnt{
    background-color: rgba(255, 255, 255, .7);
    margin: 0 10px;
    border-radius: 10px;
    padding: 16px 20px 52px;
    h4{
      margin: 0 0 10px;
    }
    .theProgress{
      display: flex;
      height: 80px;
      justify-content: space-between;
      .progressItem{
        height: 100%;
        font-size: 10px;
        text-align: center;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        position: relative;
        .label{
          position: absolute;
          left: 50%; margin-left: -15px;
          text-align: center;
          bottom: -34px;
          width: 30px;
          span{
            display: block;
            font-size: 14px;
            font-weight: bold;
            margin-top: -1px;
          }
        }
        .progress{
          width: 8px;
          background-color: #8EC642;
          background-color: #6aa722;
          border-radius: 10px;
          margin: 0 auto;
        }
      }
    }
  }
  .pointHistory{
    padding: 14px 20px 12px;
    font-weight: bold;
    color: #444;
    position: relative;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0 10px 10px;
    border-radius: 10px;
    font-size: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    transition: all .3s ease;
    cursor: pointer;
    padding-left: 48px;
    &:before{
      content: "";
      position: absolute;
      left: 10px; top: 5px; bottom: 5px; width: 30px;
      background-image: url(../assets/history.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .8;
    }
    &:hover{
      background-color: rgba(255, 255, 255, .8);
    }
    .more{
      position: absolute;
      right: 12px; top: 12px;
      width: 20px; height: 20px;
      background-position: center;
      background-size: 16px auto;
      background-repeat: no-repeat;
      background-image: url(../assets/arrow-right-black.png);
      opacity: .3;
    }
  }
  .menuCnt{
    padding: 0 0 40px;
    h4{
      margin: 0 20px 10px;
    }
    .menuSc{
      position: absolute;
      left: 0; right: 0; top: 90px; bottom: 0;
      border-top: rgba(0,0,0,.1) 1px solid;
      padding: 10px 10px 40px;
      box-sizing: border-box;
      overflow-y: auto;
    }
    .divider{
      height: 20px;
    }
    .menuItem{
      padding: 16px 20px;
      color: #444;
      position: relative;
      background-color: #fff;
      margin: 0 10px 10px;
      border-radius: 3px;
      box-sizing: border-box;
      &.loadingPrice{
        background-color: rgba(255, 255, 255, 0.5);
        background-color: transparent;
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 36px auto;
        height: 60px;
      }
      .q{
        // color: #5351a4;
        font-family: 'GolosUIWebBold', sans-serif;
        margin-bottom: 4px;
        font-size: 18px;
      }
      .a{
        font-size: 15px;
      }
    }
  }
}
</style>
